import React from "react";
import { Heart } from "lucide-react";
import { Reveal } from "./common";
import { AUTHOR } from "@/lib/site";
import authorPhoto from "@/assets/author.webp";

export const AboutAuthor = () => {
  return (
    <section id="autora" data-testid="about-author-section" className="bg-[hsl(var(--brand-mint))]/12 py-14 sm:py-20">
      <div className="mx-auto w-full max-w-5xl px-4 sm:px-6">
        <Reveal>
          <div className="grid grid-cols-1 items-center gap-8 rounded-3xl border border-[hsl(var(--border))] bg-white p-6 shadow-[0_12px_36px_rgba(31,41,55,0.08)] sm:p-10 md:grid-cols-3">
            <div className="flex justify-center md:col-span-1">
              <div className="relative h-36 w-36">
                <div className="h-36 w-36 overflow-hidden rounded-full bg-[linear-gradient(135deg,rgba(253,230,138,0.7),rgba(168,230,207,0.7))] p-1.5 shadow-[0_12px_30px_rgba(31,41,55,0.15)]">
                  <img
                    src={authorPhoto}
                    alt="Foto de la autora CreativesMar"
                    data-testid="author-photo"
                    className="h-full w-full rounded-full object-cover"
                    loading="lazy"
                  />
                </div>
                <span className="absolute -bottom-1 -right-1 flex h-10 w-10 items-center justify-center rounded-full bg-[hsl(var(--brand-coral))] text-white shadow-lg">
                  <Heart className="h-5 w-5" />
                </span>
              </div>
            </div>
            <div className="md:col-span-2">
              <span className="inline-block rounded-full bg-[hsl(var(--brand-sun))]/40 px-3 py-1 text-xs font-bold uppercase tracking-wide">
                Sobre la autora
              </span>
              <h2 className="mt-3 font-heading text-2xl font-extrabold text-[hsl(var(--brand-ink))] sm:text-3xl">
                Hola, soy {AUTHOR}
              </h2>
              <p className="mt-3 text-base leading-relaxed text-muted-foreground">
                Creo materiales pensados con amor para las familias. Sé lo mucho que te importa
                transmitir tu fe y tus valores a tus pequeños desde chiquitos, y también sé lo difícil
                que puede ser explicarles el amor de Dios sin que se aburran o se distraigan.
              </p>
              <p className="mt-3 text-base leading-relaxed text-muted-foreground">
                Por eso diseño cada página con dibujos simples y textos cortos: para que tú y tu hijo
                disfruten juntos, sin frustraciones, sembrando la palabra de Dios de la forma más
                tierna y divertida.
              </p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
